import React, { Component } from "react";
import { Link } from "react-router-dom";
import { trans } from "../../helpers/index";
import config from "../../baseConfig/index";
import AuthRightSidebar from "../Fragments/AuthRightSidebar";
import Tab from "../Fragments/Tab";
import InitMobileSteps from "./Forms/InitMobileSteps";
import MobileStep2 from "./Forms/MobileStep2";
import MobileStep3 from "./Forms/MobileStep3";
import FixedStep2 from "./Forms/FixedStep2";
import FixedStep3 from "./Forms/FixedStep3";
import FixedStep4 from "./Forms/FixedStep4";
import InitFixInternetSteps from "./Forms/InitFixInternetSteps";
import FixinStep2 from "./Forms/FixinStep2";

class AuthRegisterView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mobileStep: 1,
      mobileMaxStep: 3,
      mobileMsisdn: "",
      mobileTab: "mobile",
      mobileToken: "",
      mobileTimeLife: 0,
      mobileEmail: "",
      currentTabIndex: 0,
      fixStep: 1,
      fixMaxStep: 2,
      fixToken: "",
      fixLogin: "",
      fixBanId: "",
      fixEmail: "",
    };

    this.updateParentState = this.updateParentState.bind(this);
  }

  updateParentState(newStep) {
    this.setState(newStep);
  }

  initMobileTab() {
    return (
      <Tab
        items={[
          {
            title: trans(this.props.trans, "auth.register.tab.title1"),
            content: (
              <InitMobileSteps
                trans={this.props.trans}
                csrf_token={this.props.csrf_token}
                config={this.props.config}
                mobileConfig={this.state}
                updateParentState={this.updateParentState}
                setTokenAction={this.props.setTokenAction}
              />
            ),
          },
          {
            title: trans(this.props.trans, "auth.register.tab.title2"),
            content: (
              <InitFixInternetSteps
                trans={this.props.trans}
                csrf_token={this.props.csrf_token}
                config={this.props.config}
                fixConfig={this.state}
                updateParentState={this.updateParentState}
                setLoginAction={this.props.setLoginAction}
                setTokenAction={this.props.setTokenAction}
              />
            ),
          },
        ]}
      />
    );
  }

  mobileStep2() {
    return (
      <MobileStep2
        trans={this.props.trans}
        csrf_token={this.props.csrf_token}
        config={this.props.config}
        mobileConfig={this.state}
        updateParentState={this.updateParentState}
      />
    );
  }

  mobileStep3() {
    return (
      <MobileStep3
        trans={this.props.trans}
        csrf_token={this.props.csrf_token}
        mobileConfig={this.state}
        updateParentState={this.updateParentState}
      />
    );
  }

  fixedStep2() {
    return (
      <FixedStep2
        trans={this.props.trans}
        csrf_token={this.props.csrf_token}
        config={this.props.config}
        mobileConfig={this.state}
        updateParentState={this.updateParentState}
      />
    );
  }

  fixedStep3() {
    return (
      <FixedStep3
        trans={this.props.trans}
        csrf_token={this.props.csrf_token}
        mobileConfig={this.state}
        updateParentState={this.updateParentState}
        setLoginAction={this.props.setLoginAction}
      />
    );
  }

  fixedStep4() {
    return (
      <FixedStep4
        trans={this.props.trans}
        csrf_token={this.props.csrf_token}
        mobileConfig={this.state}
        updateParentState={this.updateParentState}
      />
    );
  }

  fixinStep2() {
    return (
      <FixinStep2
        trans={this.props.trans}
        csrf_token={this.props.csrf_token}
        fixConfig={this.state}
        updateParentState={this.updateParentState}
      />
    );
  }

  phoneFlow() {
    let result = null;

    switch (true) {
      case this.state.mobileStep === 2 && this.state.mobileTab === "mobile":
        result = this.mobileStep2();
        break;
      case this.state.mobileStep === 3 && this.state.mobileTab === "mobile":
        result = this.mobileStep3();
        break;
      case this.state.mobileStep === 2 && this.state.mobileTab === "fixed":
        result = this.fixedStep2();
        break;
      case this.state.mobileStep === 3 && this.state.mobileTab === "fixed":
        result = this.fixedStep3();
        break;
      case this.state.mobileStep === 4 && this.state.mobileTab === "fixed":
        result = this.fixedStep4();
        break;
      case this.state.fixStep === 2:
        result = this.fixinStep2();
        break;
      default:
        result = this.initMobileTab();
    }

    return result;
  }

  render() {
    return (
      <div className="main-wrapper">
        <aside className="main-wrapper__left scroller-block">
          <div className="main-wrapper__left-inner">
            <Link
              className="main-wrapper__logo sprite db"
              to={config.urlPrefix}
            >
              {trans("logo.title")}
            </Link>
            {this.phoneFlow()}
          </div>
        </aside>
        <AuthRightSidebar trans={this.props.trans} />
      </div>
    );
  }
}

export default AuthRegisterView;
